import {
  AutomationActionCreateDocumentFromTemplateDenormalized,
  IAutomationActionTemplateCreateDocumentFromTemplate
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryCreateDocumentFromTemplate = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateCreateDocumentFromTemplate
    | AutomationActionCreateDocumentFromTemplateDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t('Create a new document per Participant and insert data from Dado')}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
